import React from 'react';

interface IconProps {
  size?: number;
  color?: string;
}

// Hamburger menu style icon for columns (horizontal bars)
export const ColumnsIcon: React.FC<IconProps> = ({ size = 12, color = '#9CA3AF' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="2" width="10" height="1.5" fill={color} rx="0.5" />
    <rect x="1" y="5.25" width="10" height="1.5" fill={color} rx="0.5" />
    <rect x="1" y="8.5" width="10" height="1.5" fill={color} rx="0.5" />
  </svg>
);

// Vertical bars icon for rows
export const RowsIcon: React.FC<IconProps> = ({ size = 12, color = '#9CA3AF' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2" y="1" width="1.5" height="10" fill={color} rx="0.5" />
    <rect x="5.25" y="1" width="1.5" height="10" fill={color} rx="0.5" />
    <rect x="8.5" y="1" width="1.5" height="10" fill={color} rx="0.5" />
  </svg>
);

// Plus icon for increment
export const PlusIcon: React.FC<IconProps> = ({ size = 12, color = '#9CA3AF' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="5" y="1" width="2" height="10" fill={color} rx="1" />
    <rect x="1" y="5" width="10" height="2" fill={color} rx="1" />
  </svg>
);

// Minus icon for decrement
export const MinusIcon: React.FC<IconProps> = ({ size = 12, color = '#9CA3AF' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="5" width="10" height="2" fill={color} rx="1" />
  </svg>
);

// Arrow right icon for columns direction
export const ArrowRightIcon: React.FC<IconProps> = ({ size = 12, color = '#9CA3AF' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 6H10M10 6L6 2M10 6L6 10"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Arrow down icon for rows direction
export const ArrowDownIcon: React.FC<IconProps> = ({ size = 12, color = '#9CA3AF' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 2V10M6 10L2 6M6 10L10 6"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
